import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import OnlineNotarization from '../components/OnlineNotarization';


const Home = () => {
  return (
    <main>
      <Hero />
      <Services />
      <About />
      <OnlineNotarization />
    
    </main>
  );
};

export default Home;